import { Apps } from '../app/core/enums/Apps';

export const environment = {
  production: false,
  version: 'dev-7623',
  fallbackLanguage: 'de',
  apiUrl: 'https://dev.api.cinetixx.com/api/v1',
  servicesDateFormat: 'YYYY-MM-DD',
  servicesDateTimeFormat: 'YYYY-MM-DD HH:mm',
  defaultDateFormat: 'dd.MM.yyyy',
  defaultTimeFormat: 'HH:mm',
  versionPrefix: 'dev',
  app: Apps.CxCash,
  wsUrl: 'https://dev.api.cinetixx.com/signalr',
  cxEntryUrl: 'https://dev.entry.cinetixx.com/',
  tubeUrl: 'https://dev.tube.cinetixx.com/',
  dsn: "https://fdc3a24948031a9e596bf2e033d96c74@o4508816761225216.ingest.de.sentry.io/4510442775183440",
  appUrl: 'https://dev.cash.cinetixx.com',
  sumUpDevReader: true,
};
